/**
 * Página de coleção: aplica os filtros automaticamente ao marcar/desmarcar uma opção
 * e recolhe o painel de filtros no celular (no computador ele fica sempre aberto).
 * Sem este script, o botão "Aplicar filtros" envia o formulário normalmente.
 */
(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  const boot1 = (scope = document) =>
    scope.querySelectorAll('[data-filters-form]').forEach((form) => {
    if (form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    form.dataset.auto = 'true';

    let timer;
    const submit = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => form.requestSubmit(), 250);
    };

    // Os campos ficam fora do <form>, ligados a ele pelo atributo "form"
    document.querySelectorAll(`[form="${form.id}"]`).forEach((field) => {
      if (field.matches('input[type="checkbox"], input[type="number"]')) {
        field.addEventListener('change', submit);
      }
    });
  });
  boot1();
  document.addEventListener('shopify:section:load', (event) => boot1(event.target));

  const boot2 = (scope = document) =>
    scope.querySelectorAll('[data-filters-panel]').forEach((panel) => {
    if (panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';

    const sync = () => {
      panel.open = desktop.matches;
    };
    sync();
    desktop.addEventListener('change', sync);

    // No computador o painel não pode ser fechado
    panel.addEventListener('toggle', () => {
      if (desktop.matches && !panel.open) panel.open = true;
    });
  });
  boot2();
  document.addEventListener('shopify:section:load', (event) => boot2(event.target));
})();
